import _createFocusTrap from 'focus-trap';
export { default as classNames } from 'classnames';
export * from './with-theme';
export * from './utils';
export { FoundationComponent } from './foundation-component';
export { componentFactory } from './component';
export var createFocusTrap = _createFocusTrap;